import { Store } from '@ngrx/store';
import { FilterStorageState, TableContext } from './filter.reducer';
import { resetFilter } from './filter.actions';
import { getFilterStateForKey } from './filter.selector';
import { map, Observable } from 'rxjs';
import { SortAttributes } from '@markant-platform/shared/table/model';

export function initFilterState(
  store: Store,
  storeSubcontext: TableContext,
  defaultFilter: Record<string, string[]>,
  defaultSort?: SortAttributes,
  hiddenColumns?: string[]
): Observable<FilterStorageState> {
  return store.select(getFilterStateForKey(storeSubcontext)).pipe(
    map(filter => {
      if (filter?.filterInitialized) {
        return structuredClone(filter);
      }

      store.dispatch(
        resetFilter({
          key: storeSubcontext,
          defaultFilter,
          defaultSort,
        })
      );

      return structuredClone({
        activeFilter: defaultFilter,
        page: { index: 1, size: 25 },
        searchQuery: '',
        sort: defaultSort,
        hiddenColumns: filter?.hiddenColumns || hiddenColumns,
      });
    })
  );
}
